import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    templateUrl: './training-skill-card.component.html',
    selector: 'lok-training-skill-card',
    styleUrls: ['./training-skill-card.component.scss'],
    standalone: false
})
export class TrainingSkillCardComponent {
    @Input() asset!: any;
    @Input() index!: number;
    @Input() readOnly = false;
    @Output() editTraining = new EventEmitter();
    @Output() deleteTraining = new EventEmitter();
    @Input() livelihoodActivitiesData: any[] = [];

    edit () {
        this.editTraining.emit({ index: this.index });
    }

    delete () {
        this.deleteTraining.emit({ index: this.index });
    }
      getLabelByValue(value: string): string | null {
  for (const group of this.livelihoodActivitiesData) {
    const found = group.data.find((item:any) => item.value === value);
    if (found) {
      return found.label; // or found.enLabel if you want English label
    }
  }
  return null;
}
}
